import { Droplets, Brain, Target, BarChart3 } from "lucide-react";

const ValueProposition = () => {
  const benefits = [
    {
      icon: Droplets,
      title: "Test en conditions réelles",
      description:
        "Fini le papier. Votre parfum est testé sur la peau, dans un contexte de vie réel."
    },
    {
      icon: Brain,
      title: "Meilleure mémorisation",
      description:
        "L'expérience olfactive répétée ancre votre fragrance dans la mémoire du consommateur."
    },
    {
      icon: Target,
      title: "Audience ciblée & captive",
      description:
        "Des consommateurs urbains, actifs, soucieux de leur image. Votre cible idéale."
    },
    {
      icon: BarChart3,
      title: "Données & visibilité",
      description:
        "Suivez les performances en temps réel. Optimisez votre stratégie de distribution."
    }
  ];

  return (
    <section
      id="avantages"
      data-testid="value-proposition-section"
      className="bg-[#FAFAFA] py-24 md:py-32 lg:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Label */}
        <p
          data-testid="value-label"
          className="font-body text-sm tracking-[0.2em] uppercase text-[#B89F7C] mb-6"
        >
          Notre Solution
        </p>

        {/* Main Headline */}
        <h2
          data-testid="value-headline"
          className="font-heading text-4xl sm:text-5xl font-light tracking-tight leading-tight text-[#0A0A0A] mb-16 max-w-3xl"
        >
          Un nouveau canal de visibilité,
          <br />
          <span className="italic">expérientiel et ciblé</span>
        </h2>

        {/* Benefits Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              data-testid={`value-card-${benefit.title.toLowerCase().replace(/\s+/g, '-')}`}
              className="bg-white border border-[#E5E5E5] p-8 hover:border-[#B89F7C] transition-colors duration-500"
            >
              <benefit.icon
                strokeWidth={1}
                size={32}
                className="text-[#0A0A0A] mb-6"
              />
              <h3 className="font-heading text-xl font-normal text-[#0A0A0A] mb-4">
                {benefit.title}
              </h3>
              <p className="font-body text-sm font-light leading-relaxed text-[#525252]">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
